import { gql } from '@apollo/client';

export const GET_STATE_TAX_RATES = gql`
  query GetStateTaxRates {
    stateTaxRates {
      stateCode
      individual
      cCorp
      sCorp
      insertDate
      insertUser
      modifiedDate
      modifiedUser
    }
  }
`;

